import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import axios from 'axios';
import { getRole } from '../../utils/authUtils';

const PageContainer = styled.div`
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
`;

const Card = styled.div`
  max-width: 480px;
  width: 100%;
  background-color: white;
  padding: 2rem;
  border-radius: 0px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  text-align: center;
`;

const SuccessMessage = styled.div`
  background-color: #d4edda;
  color: #155724;
  padding: 1rem;
`;

const ErrorMessage = styled.div`
  background-color: #f8d7da;
  color: #721c24;
  padding: 1rem;
`;

const VerifyEmail = () => {
  const intl = useIntl();
  const t = (id, defaultMessage, values) => intl.formatMessage({ id, defaultMessage }, values);
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('checking');
  const [registeredEventName, setRegisteredEventName] = useState(null);

  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const run = async () => {
      if (!token) {
        setStatus('error');
        return;
      }
      try {
        // Any event the attendee meant to register for at signup time is
        // tracked server-side on the verification token and completed as
        // part of this call - works even if this link is opened on a
        // different device than the one used to sign up.
        const { data } = await axios.get(`${apiUrl}/api/attendee/public/verify-email`, { params: { token } });
        setStatus('success');
        if (data.registeredEventName) {
          setRegisteredEventName(data.registeredEventName);
        }
      } catch (err) {
        setStatus('error');
      }
    };
    run();
  }, [token]);

  return (
    <PageContainer>
      <Card>
        {status === 'checking' && <p>{t('verify.checking', 'Verifying your email…')}</p>}
        {status === 'success' && (
          <SuccessMessage>
            <p>{t('verify.success', 'Your email has been verified.')}</p>
            {registeredEventName && (
              <p>{t('verify.eventRegistered', 'You\'re now registered for {eventName}.', { eventName: registeredEventName })}</p>
            )}
            <p><Link to={getRole() ? '/profile' : '/login'}>{getRole() ? t('nav.myProfile', 'Go to my profile') : t('auth.signIn', 'Sign in')}</Link></p>
          </SuccessMessage>
        )}
        {status === 'error' && (
          <ErrorMessage>
            <p>{t('verify.error', 'This verification link is invalid or has expired.')}</p>
          </ErrorMessage>
        )}
      </Card>
    </PageContainer>
  );
};

export default VerifyEmail;
